export enum ConnectionTicketStatus {
    Pending = 'Pending',
    Rejected = 'Rejected',
    Confirmed = 'Confirmed',
}
